import { styled } from 'styled-components'

import { Reset } from '@/lib/mixins'

export const InputQtyWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 32px;
`

export const InputQtyValue = styled.div`
  font-weight: 500;
  font-size: 28px;
  text-align: center;
  width: 48px;
  margin: 0 4px;
  color: ${props => props.theme.color.black};
`
export const InputQtyButton = styled.button`
  ${Reset('button')}
  display: flex;
  width: 56px;
  height: 56px;
  border: 2px solid ${props => props.theme.color.black};
  border-radius: 28px;
  align-items: center;
  justify-content: center;
  opacity: ${props => (props.disabled ? 0.3 : 1)};
`
